"use client";

import { useEffect, useRef } from "react";

/**
 * Marker rendered inside a `buttons` content type with `data-same-width="true"`.
 * Mirrors Magento `buttons/appearance/inline/widget.js#equalizeButtonWidth`:
 * every link gets `min-width` equal to the widest one, recomputed on resize
 * (ResizeObserver also catches late web-font swaps).
 */
export function PbSameWidthButtons() {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const container = ref.current?.parentElement;
    if (!container) return;
    const buttons = () =>
      Array.from(container.querySelectorAll<HTMLElement>('[data-element="link"], [data-element="empty_link"]'));

    let frame = 0;
    const equalize = () => {
      frame = 0;
      const list = buttons();
      list.forEach((b) => (b.style.minWidth = "0"));
      const max = Math.max(0, ...list.map((b) => b.offsetWidth));
      list.forEach((b) => (b.style.minWidth = `${max}px`));
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(equalize);
    };

    equalize();
    const ro = new ResizeObserver(schedule);
    ro.observe(container);
    return () => {
      ro.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return <span ref={ref} hidden data-pb-same-width="" />;
}
